(function () {
  if (!customElements.get('location-gate')) {
    var LOCATION_RESOLVED_KEY = 'locationGate:resolved';

    // Inerts every element under <body> except `allowedEl` (and its
    // ancestors), leaving the rest of the page unusable until the shopper
    // deals with it. Mirrors snippets/cookie-consent-gate.liquid, but scoped
    // to a single nested element instead of body's direct children, since
    // the location gate lives inside <main> alongside every other homepage
    // section.
    function lockPageExcept(allowedEl, locked) {
      function walk(node) {
        Array.from(node.children).forEach(function (child) {
          if (child === allowedEl || child.contains(allowedEl)) {
            child.removeAttribute('inert');
            if (child !== allowedEl) walk(child);
            return;
          }
          if (locked) {
            child.setAttribute('inert', '');
          } else {
            child.removeAttribute('inert');
          }
        });
      }
      walk(document.body);
    }

    customElements.define(
      'location-gate',
      class LocationGate extends HTMLElement {
        constructor() {
          super();
          this.toggle = this.querySelector('.location-gate__toggle');
          this.panel = this.querySelector('.location-gate__list-wrapper');
          this.options = Array.from(this.querySelectorAll('.location-gate__option'));
          // One country list per multi-country region ("European Union",
          // "Rest of the world"), matched to its option via data-region-panel.
          this.countryPanels = Array.from(this.querySelectorAll('.location-gate__country-panel'));
          this.countryOptions = Array.from(this.querySelectorAll('.location-gate__country'));
          this.confirmButton = this.querySelector('.location-gate__confirm');
          this.countryInput = this.querySelector('input[name="country_code"]');
          this.currentLabel = this.querySelector('[data-location-gate-current]');
          this.initialCountry = this.countryInput.value;
          // Set when the picked option (Japan/Taiwan/Korea) has its own
          // redirect URL configured in the theme editor.
          this.redirectUrl = '';
          this.pending = false;

          // Geolocation detected a country served by another store (e.g. a
          // visitor in Japan on sibarist.coffee): don't preselect it. Where
          // someone is located isn't where they want to buy (e.g. at a fair
          // abroad), so they must pick explicitly; "Confirm" stays disabled
          // until they do, then redirects or switches country as usual.
          const currentOption = this.options.find((option) => option.getAttribute('aria-current') === 'true');
          if (currentOption) {
            const currentPanel = this.querySelector(`.location-gate__country-panel[data-region-panel="${currentOption.dataset.region}"]`);
            const currentCountry = currentPanel && currentPanel.querySelector('[aria-current="true"]');
            const leavesStore = currentPanel ? currentCountry && currentCountry.dataset.url : currentOption.dataset.url;
            if (leavesStore) {
              [currentOption, currentCountry].forEach((item) => {
                if (!item) return;
                item.classList.remove('location-gate__option--current');
                item.removeAttribute('aria-current');
              });
              if (this.currentLabel) this.currentLabel.textContent = this.currentLabel.dataset.placeholder || '';
              this.confirmButton.disabled = true;
            }
          }

          this.nameAndSortCountries();

          this.toggle.addEventListener('click', this.onToggleClick.bind(this));
          this.options.forEach((option) => option.addEventListener('click', this.onOptionClick.bind(this)));
          this.countryOptions.forEach((option) => option.addEventListener('click', this.onCountryClick.bind(this)));
          this.confirmButton.addEventListener('click', this.onConfirmClick.bind(this));
          this.addEventListener('focusout', this.onFocusOut.bind(this));
          this.addEventListener('keyup', this.onKeyUp.bind(this));
        }

        // Countries that aren't active markets in this store (the duplicate
        // stores only sell to their own country) are rendered with just
        // their ISO code; name them in the page's language and re-sort each
        // list alphabetically so they read like the main store's lists.
        nameAndSortCountries() {
          let displayNames = null;
          try {
            displayNames = new Intl.DisplayNames([document.documentElement.lang || 'en', 'en'], { type: 'region' });
          } catch (error) {
            // Intl.DisplayNames unavailable: keep the ISO codes.
          }

          this.countryPanels.forEach((panel) => {
            const list = panel.querySelector('.location-gate__country-list');
            const items = Array.from(list.children);
            if (displayNames) {
              items.forEach((item) => {
                const button = item.querySelector('[data-needs-name]');
                if (!button) return;
                const name = displayNames.of(button.dataset.country);
                if (name) button.textContent = name;
              });
            }
            items
              .sort((a, b) => a.textContent.trim().localeCompare(b.textContent.trim(), document.documentElement.lang || 'en'))
              .forEach((item) => list.appendChild(item));
          });
        }

        connectedCallback() {
          this.initMandatoryLock();
        }

        initMandatoryLock() {
  if (window.Shopify && window.Shopify.designMode) {
    this.hide();
    return;
  }

  var resolvedBefore = false;

  // Arriving from a duplicate store (japan.sibarist.coffee, ...) where the
  // shopper already picked their country: don't ask again here.
  try {
    var url = new URL(window.location.href);
    if (url.searchParams.get('location_gate') === 'resolved') {
      this.markResolved();
      url.searchParams.delete('location_gate');
      window.history.replaceState(window.history.state, '', url.toString());
    }
  } catch (error) {
    // URL/history unavailable: the selector just shows as usual.
  }

  try {
    resolvedBefore = window.localStorage.getItem(LOCATION_RESOLVED_KEY) === '1';
  } catch (error) {
    // Storage unavailable: leave the selector visible for this visit.
  }

  if (resolvedBefore) {
    this.hide();
    // layout/theme.liquid may have added this before first paint (it can't
    // see ?location_gate=resolved being stored yet): drop it so the header
    // menu shows.
    document.documentElement.classList.remove('location-gate-pending');
  }
}

        engageMandatoryLock() {
          // Mandatory just means the shopper can't dismiss/ignore it without
          // picking something — it does not mean force the panel open. It
          // starts collapsed (toggle + caret, see the `hidden` attribute
          // already on the panel in the markup) like a normal disclosure;
          // the shopper opens it themselves via the toggle.
          this.pending = true;
          document.documentElement.classList.add('location-gate-pending');
          lockPageExcept(this, true);
        }

        resolveMandatoryLock() {
          if (!this.pending) return;
          this.pending = false;
          document.documentElement.classList.remove('location-gate-pending');
          lockPageExcept(this, false);
        }

        markResolved() {
          try {
            window.localStorage.setItem(LOCATION_RESOLVED_KEY, '1');
          } catch (error) {
            // Storage unavailable: nothing to persist, the picker will
            // simply ask again next visit.
          }
        }

        hide() {
          document.documentElement.classList.add('location-gate-resolved');
        }

        onToggleClick() {
          const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
          // Mandatory: can open it, but can't collapse it again without
          // resolving first (still has to pick something).
          if (this.pending && expanded) return;
          this.toggle.setAttribute('aria-expanded', (!expanded).toString());
          this.panel.toggleAttribute('hidden', expanded);
          // Lets the hero video/header dim and hide while the shopper is
          // actively picking a region, the same way they do while the
          // cookie consent banner (or the mandatory first-visit lock) is
          // pending.
          document.documentElement.classList.toggle('location-gate-open', !expanded);
        }

        onOptionClick(event) {
          const option = event.currentTarget;
          this.options.forEach((item) => {
            const isSelected = item === option;
            item.classList.toggle('location-gate__option--current', isSelected);
            if (isSelected) {
              item.setAttribute('aria-current', 'true');
            } else {
              item.removeAttribute('aria-current');
            }
          });
          if (this.currentLabel) this.currentLabel.textContent = option.textContent.trim();
          this.redirectUrl = option.dataset.url || '';

          const countryPanel = this.countryPanels.find((panel) => panel.dataset.regionPanel === option.dataset.region);
          this.countryPanels.forEach((panel) => {
            panel.hidden = panel !== countryPanel;
          });

          if (countryPanel) {
            // "European Union" / "Rest of the world" span several
            // countries: list them directly instead of silently picking a
            // representative one. Staged only — nothing submits until
            // "Confirm" is pressed, which stays disabled until a country
            // in the list is chosen.
            const preselected = countryPanel.querySelector('[aria-current="true"]');
            const label = countryPanel.querySelector('[data-location-gate-current-country]');
            this.redirectUrl = preselected ? preselected.dataset.url || '' : '';
            if (preselected) {
              this.countryInput.value = preselected.dataset.country;
              if (label) label.textContent = preselected.textContent.trim();
            } else if (label) {
              label.textContent = '';
            }
            this.confirmButton.disabled = !preselected;
            return;
          }

          this.confirmButton.disabled = false;
          this.countryInput.value = option.dataset.country;
          this.closeAfterPick();
        }

        // Confirm sits outside the dropdown, which overlays it while open:
        // close it once the choice is final (like a native select) and move
        // focus to Confirm so it's the obvious next step.
        closeAfterPick() {
          this.toggle.setAttribute('aria-expanded', 'false');
          this.panel.setAttribute('hidden', '');
          document.documentElement.classList.remove('location-gate-open');
          this.confirmButton.focus();
        }

        onCountryClick(event) {
          const button = event.currentTarget;
          const panel = button.closest('.location-gate__country-panel');
          const label = panel.querySelector('[data-location-gate-current-country]');
          this.countryOptions.forEach((item) => {
            const isSelected = item === button;
            item.classList.toggle('location-gate__option--current', isSelected);
            if (isSelected) {
              item.setAttribute('aria-current', 'true');
            } else {
              item.removeAttribute('aria-current');
            }
          });
          this.countryInput.value = button.dataset.country;
          // Not an active market in this store: Confirm sends the shopper to
          // the main store with this country instead.
          this.redirectUrl = button.dataset.url || '';
          this.confirmButton.disabled = false;
          if (label) label.textContent = button.textContent.trim();
          // Show the actual country on the toggle, since the dropdown (and
          // with it the "Select your location: Spain" line) now closes.
          if (this.currentLabel) this.currentLabel.textContent = button.textContent.trim();
          this.closeAfterPick();
        }

        onConfirmClick(event) {
          this.markResolved();

          if (this.redirectUrl) {
            // Japan/Taiwan/Korea with a custom URL, or a country this
            // store doesn't sell to: leave this store instead of switching
            // its country.
            event.preventDefault();
            window.location.href = this.withResolvedFlag(this.redirectUrl);
            return;
          }

          if (this.countryInput.value === this.initialCountry) {
            // Nothing actually changed (the shopper just confirmed the
            // detected default): no need for a real form submit/page
            // reload, just close the picker, unlock the rest of the page,
            // and make the whole widget disappear.
            event.preventDefault();
            this.resolveMandatoryLock();
            // Also set before first paint by layout/theme.liquid on the
            // duplicate stores, without engaging the lock: always clear it
            // so the header menu appears right after confirming.
            document.documentElement.classList.remove('location-gate-pending');
            this.toggle.setAttribute('aria-expanded', 'false');
            this.panel.setAttribute('hidden', '');
            document.documentElement.classList.remove('location-gate-open');
            this.hide();
            return;
          }

          // Otherwise let the form submit for real: it reloads the page
          // with the new country/currency. `locationGate:resolved`,
          // already set above, carries over so the picker won't force
          // itself open again.
        }

        // The destination store has its own localStorage (different origin),
        // so tell it the country is already chosen: it then skips the gate
        // and shows its menu straight away.
        withResolvedFlag(href) {
          try {
            const url = new URL(href, window.location.href);
            url.searchParams.set('location_gate', 'resolved');
            return url.toString();
          } catch (error) {
            return href;
          }
        }

        onKeyUp(event) {
          if (this.pending) return;
          if (event.key === 'Escape' && this.toggle.getAttribute('aria-expanded') === 'true') {
            this.onToggleClick();
            this.toggle.focus();
          }
        }

        onFocusOut(event) {
          if (this.pending) return;
          if (!this.contains(event.relatedTarget)) {
            this.toggle.setAttribute('aria-expanded', 'false');
            this.panel.setAttribute('hidden', '');
            document.documentElement.classList.remove('location-gate-open');
          }
        }
      }
    );
  }
})();
